module.exports = __webpack_public_path__ + "img/block3.7f8a7d30.webp";